import { Card } from "@mui/material";
import { styled } from "@mui/material/styles";

export const SocialMediaContainer = styled(Card)(({ theme }) => ({
	width: "100%",
	padding: "1rem 1.5rem",
	height: "fit-content",
	"min-height": "100px",
	boxShadow: "0px 15px 40px #77777729",
	borderRadius: "5px",
	gridArea: "social",
	margin: "0",
	opacity: 1,
	display: "flex",
	justifyContent: "center",
	flexDirection: "column",
	[theme.breakpoints.up("xl")]: {
		padding: "1.75rem 1.5rem",
	},
}));

export const Title = styled("div")(({ theme }) => ({
	color: theme.typography.h2.color,
	fontSize: "1rem",
	fontWeight: 700,
	marginBottom: "0.5rem",
	[theme.breakpoints.up("md")]: {
		fontSize: "0.75rem",
		fontWeight: 700,
	},
	[theme.breakpoints.up("lg")]: {
		fontSize: "1.2rem",
		fontWeight: 700,
	},
	[theme.breakpoints.up("xl")]: {
		fontSize: "1.5rem",
		fontWeight: 700,
	},
}));

export const Icons = styled("div")(({ theme }) => ({
	display: "flex",
	gap: "0.75rem",
	fontWeight: 700,
	"& > svg": {
		height: "2rem",
		width: "2rem",
	},
	[theme.breakpoints.down("lg")]: {
		gap: "0.5rem",
		"& > svg": {
			height: "1rem",
			width: "1rem",
		},
	},
	[theme.breakpoints.up("lg")]: {
		"& > svg": {
			height: "1.75rem",
			width: "1.75rem",
		},
	},
	[theme.breakpoints.up("xl")]: {
		gap: "1.25rem",
		"& > svg": {
			height: "2.5rem",
			width: "2.5rem",
		},
	},
}));
